<template>
  <div ref="dashboardEditor" class="dashboard-editor-container">
      <div class="cardBox" style="padding-bottom: 0px; margin-bottom: -10px">
          <el-row :gutter="20" align="middle" justify="space-between">
              <el-col :span="6" key="1">
                  <el-row type="flex" justify="space-around" align="middle">
                      <el-col
                          :span="4"
                          v-for="(item, index) in list"
                          :key="index"
                          style="line-height: 100px"
                      >
                          <el-button
                              style="
                                  height: 50px;
                                  padding: 5px;
                                  min-width: 100%;
                              "
                              @click="getFlow(item.id)"
                              round
                              :type="item.type"
                          >
                              <img
                                  width="20px"
                                  height="20px"
                                  :src="
                                      require('@/assets/OA/' +
                                          item.icon +
                                          '.png')
                                  "
                                  alt=""
                              />
                              <div class="buttonTitle">
                                  {{ item.name }}
                              </div>
                          </el-button>
                      </el-col>
                  </el-row>
              </el-col>
              <el-col :span="12" key="2">
                  <div
                      style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                      "
                  >
                      <!--<img height="110px" src="@/assets/logo/iconLogo.jpg" alt="" />-->
                      <!-- <span class="welcom">广西来宾广投银海铝业有限公司</span> -->
                  </div>
              </el-col>
              <el-col :span="6" key="3">
                  <span class="welcom" style="color: #1890ff"
                      >总人数：{{ alltotal }}</span
                  >
              </el-col>
          </el-row>
      </div>
      <div class="cardBox">
          <el-row :gutter="20">
              <el-col :span="6">
                  <el-card class="card col-item">
                      <div slot="header">
                          <h4>审批中心</h4>
                      </div>
                      <div class="bodyer" style="padding: 0 25px">
                          <div class="buttonGround">
                              <el-badge
                                  class="item"
                                  :value="item.num"
                                  :hidden="item.num == 0"
                                  v-for="(item, index) in buttonList1"
                                  :key="index"
                              >
                                  <el-button
                                      class="button"
                                      @click="push(item.url)"
                                      :type="item.type"
                                      plain
                                  >
                                      <img
                                          class="icon"
                                          :src="
                                              require('@/assets/OA/' +
                                                  item.icon +
                                                  '.png')
                                          "
                                          alt=""
                                      />
                                      <div class="buttonTitle">
                                          {{ item.name }}
                                      </div>
                                  </el-button>
                              </el-badge>
                          </div>
                          <div class="buttonGround" style="margin-top: 10px">
                              <el-badge
                                  class="item"
                                  :value="item.num"
                                  :hidden="item.num == 0"
                                  v-for="(item, index) in buttonList2"
                                  :key="index"
                              >
                                  <el-button
                                      class="button"
                                      @click="push(item.url)"
                                      :type="item.type"
                                      plain
                                  >
                                      <img
                                          class="icon"
                                          :src="
                                              require('@/assets/OA/' +
                                                  item.icon +
                                                  '.png')
                                          "
                                          alt=""
                                      />
                                      <div class="buttonTitle">
                                          {{ item.name }}
                                      </div>
                                  </el-button>
                              </el-badge>
                          </div>
                      </div>
                  </el-card>
              </el-col>
              <el-col :span="12">
                  <el-carousel trigger="click" height="340px">
                      <el-carousel-item
                          v-for="(item, index) of swiper"
                          :key="index"
                      >
                          <img
                              style="width: 100%; height: 100%"
                              :src="item.image"
                              alt=""
                          />
                          <h3 class="carousel-item">{{ item.content }}</h3>
                      </el-carousel-item>
                  </el-carousel>
              </el-col>
              <el-col :span="6">
                  <el-card class="card col-item">
                      <div slot="header">
                          <h4>
                              <span
                                  v-if="bread.length > 1"
                                  @click="backDeptList()"
                                  style="margin-right: 5px; cursor: pointer"
                                  >◀</span
                              >通讯录
                          </h4>
                      </div>
                      <div class="bodyer">
                          <el-input
                              v-model="show"
                              placeholder="请输入姓名"
                              clearable
                              @keydown.native.enter="search()"
                              @clear="search()"
                          >
                              <el-button
                                  slot="append"
                                  icon="el-icon-search"
                                  @click="search()"
                              ></el-button>
                          </el-input>
                          <el-table
                              :data="showList"
                              :show-header="false"
                              @row-click="changeDept"
                              :row-style="rowStyle"
                              @cell-click="userChange"
                          >
                              <el-table-column
                                  prop="name"
                                  :show-overflow-tooltip="true"
                              >
                                  <template slot-scope="scope">
                                      {{ scope.row.name }}
                                      <span
                                          vv-if="scope.row.deptname"
                                          style="margin-left: 10px"
                                          >{{ scope.row.deptname }}</span
                                      >
                                  </template>
                              </el-table-column>

                              <el-table-column width="110" prop="phone">
                              </el-table-column>
                          </el-table>
                          <el-pagination
                              class="bottom"
                              @prev-click="last('user')"
                              @next-click="add('user')"
                              @current-change="changePage"
                              :current-page="pageNum"
                              :page-size="5"
                              layout="total, prev, pager, next"
                              :total="total"
                          >
                          </el-pagination>
                      </div>
                  </el-card>
              </el-col>
          </el-row>
      </div>
      <div ref="cardBox" class="cardBox">
          <el-row :gutter="20">
              <el-col ref="tzgg" :span="8">
                  <el-card class="card col-item">
                      <div slot="header">
                          <h4>
                              通知公告
                              <span
                                  class="bgindex-more"
                                  @click="domore('tzgg')"
                                  >更多>></span
                              >
                          </h4>
                      </div>
                      <div class="bodyer">
                          <el-table
                              :data="noticeList"
                              style="width: 100%"
                              :show-header="false"
                              @row-click="goDetail"
                              :cell-style="cellStyle"
                              :row-style="rowStyle"
                          >
                              <el-table-column width="15">
                                  <div class="circle"></div>
                              </el-table-column>
                              <el-table-column
                                  prop="title"
                                  :show-overflow-tooltip="true"
                              >
                              </el-table-column>
                              <el-table-column
                                  prop="update_time"
                                  align="right"
                              >
                              </el-table-column>
                          </el-table>
                          <el-pagination
                              class="bottom"
                              @prev-click="last('notice')"
                              @next-click="add('notice')"
                              @current-change="changenoticePage"
                              :page-size="5"
                              layout="total, prev, pager, next"
                              :total="noticetotal"
                          >
                          </el-pagination>
                      </div>
                  </el-card>
              </el-col>
              <el-col :span="8">
                  <el-card class="card col-item">
                      <div slot="header">
                          <h4>
                              学习园地
                              <span
                                  class="bgindex-more"
                                  @click="domore('xxyd')"
                                  >更多>></span
                              >
                          </h4>
                      </div>
                      <div class="bodyer">
                          <el-table
                              :data="newsList"
                              style="width: 100%"
                              :show-header="false"
                              @row-click="goDetail"
                              :cell-style="cellStyle"
                              :row-style="rowStyle"
                          >
                              <el-table-column width="15">
                                  <div class="circle"></div>
                              </el-table-column>
                              <el-table-column
                                  prop="title"
                                  :show-overflow-tooltip="true"
                              >
                              </el-table-column>
                              <el-table-column
                                  prop="update_time"
                                  align="right"
                              >
                              </el-table-column>
                          </el-table>
                          <el-pagination
                              class="bottom"
                              @prev-click="last('news')"
                              @next-click="add('news')"
                              @current-change="changenewsPage"
                              :page-size="5"
                              layout="total, prev, pager, next"
                              :total="newstotal"
                          >
                          </el-pagination>
                      </div>
                  </el-card>
              </el-col>
              <el-col :span="8">
                  <el-card class="card col-item">
                      <div slot="header">
                          <h4>
                              制度管理<span
                                  class="bgindex-more"
                                  @click="domore('zdgl')"
                                  >更多>></span
                              >
                          </h4>
                      </div>
                      <div class="bodyer">
                          <el-table
                              :data="fileList"
                              style="width: 100%"
                              :show-header="false"
                              @row-click="goDetail"
                              :cell-style="cellStyle"
                              :row-style="rowStyle"
                          >
                              <el-table-column width="15">
                                  <div class="circle"></div>
                              </el-table-column>
                              <el-table-column
                                  prop="title"
                                  :show-overflow-tooltip="true"
                              >
                              </el-table-column>
                              <el-table-column
                                  prop="update_time"
                                  align="right"
                              >
                              </el-table-column>
                          </el-table>
                          <el-pagination
                              class="bottom"
                              @prev-click="last('file')"
                              @next-click="add('file')"
                              @current-change="changefilePage"
                              :page-size="5"
                              layout="total, prev, pager, next"
                              :total="filetotal"
                          >
                          </el-pagination>
                      </div>
                  </el-card>
              </el-col>
          </el-row>
      </div>
  </div>
</template>

<script>
import PanelGroup from "../dashboard/PanelGroup";
import LineChart from "../dashboard/LineChart";
import RaddarChart from "../dashboard/RaddarChart";
import PieChart from "../dashboard/PieChart";
import BarChart from "../dashboard/BarChart";
import svgIcon from "@/components/SvgIcon";
import { getBpmFlow } from "@/api/bpm/flow";
import { listUser } from "@/api/core/system/user";
import { listCmsBlock } from "@/api/cms/block";
import { getRouters } from "@/api/menu.js";
import { listDocument } from "@/api/general/document.js";
import { listDocumenttype } from "@/api/general/documenttype.js";
import { listCmsArchives } from "@/api/cms/archives.js";
import { FormxShowList } from "@/api/form/data.js";
import { StatProcess } from "@/api/bpm/process.js";
import { listDept } from "@/api/core/system/dept";



const lineChartData = {
  newVisitis: {
      expectedData: [100, 120, 161, 134, 105, 160, 165],
      actualData: [120, 82, 91, 154, 162, 140, 145],
  },
  messages: {
      expectedData: [200, 192, 120, 144, 160, 130, 140],
      actualData: [180, 160, 151, 106, 145, 150, 130],
  },
  purchases: {
      expectedData: [80, 100, 121, 104, 105, 90, 100],
      actualData: [120, 90, 100, 138, 142, 130, 130],
  },
  shoppings: {
      expectedData: [130, 140, 141, 142, 145, 150, 160],
      actualData: [120, 82, 91, 154, 162, 140, 130],
  },
};

export default {
  name: "dashboard",
  components: {
      PanelGroup,
      LineChart,
      RaddarChart,
      PieChart,
      BarChart,
      svgIcon,
  },
  data() {
      return {
          alldoctype: [],
          templist: [],
          title: process.env.VUE_APP_TITLE,
          subtitle: process.env.VUE_APP_SUB_TITLE,
          lineChartData: lineChartData.newVisitis,
          list: [
              {
                  name: "作业票",
                  id: "作业票",
                  icon: "if-safety-hat",
                  type: "primary",
              },
              {
                  name: "隐患排查",
                  id: "75",
                  icon: "md-find_in_page",
                  type: "success",
              },
              {
                  name: "隐患汇报",
                  id: "70",
                  icon: "fa5-paper-plane-fas",
                  type: "warning",
              },

              {
                  name: "更多",
                  id: "more",
                  icon: "more",
                  type: "info",
              },
          ],
          buttonList1: [
              {
                  name: "待办",
                  icon: "todo",
                  type: "primary",
                  url: "bpm/process/todoList",
                  num: 0,
              },
              {
                  name: "已办",
                  icon: "finish",
                  type: "primary",
                  url: "bpm/process/doneList",
                  num: 0,
              },
          ],
          buttonList2: [
              {
                  name: "我发起的",
                  icon: "createMe",
                  type: "primary",
                  url: "bpm/process/myList",
                  num: 0,
              },
              {
                  name: "抄送我的",
                  icon: "toMe",
                  type: "primary",
                  url: "bpm/process/copyList",
                  num: 0,
              },
          ],
          noticeList: [],
          fileList: [],
          newsList: [],
          showList: [],
          total: 0,
          noticetotal: 1,
          filetotal: 1,
          newstotal: 1,
          alltotal: 1,
          swiper: [],
          tableData: [],
          pageNum: 1,
          noticepageNum: 1,
          filepageNum: 1,
          newspageNum: 1,
          value: "",
          show: "",
          bread: [],
          typechildta: {},
      };
  },
  mounted() {
      /*listDocumenttype({
      pageSize: 999,
      pageNum: 1,
    }).then((rs) => {
      this.alldoctype = rs.data.list;

      this.alldoctype = this.handleTree(this.alldoctype, "id", "pid");

      console.log("this.alldoctype", this.alldoctype);

      for (var i in this.alldoctype) {
        if (this.alldoctype[i].id == 13) {
          this.templist = [];
          this.getallchilddocid([this.alldoctype[i]], this.templist);
          this.templist.push("13");
          this.typechildta["notice"] = this.templist.join(",");
          this.getnoticeList(1, this.templist.join(","));
        } else if (this.alldoctype[i].id == 14) {
          this.templist = [];
          this.getallchilddocid([this.alldoctype[i]], this.templist);
          this.templist.push("14");
          this.typechildta["file"] = this.templist.join(",");
          this.getfileList(1, this.templist.join(","));
        } else if (this.alldoctype[i].id == 19) {
          this.templist = [];
          this.getallchilddocid([this.alldoctype[i]], this.templist);
          this.templist.push("19");
          this.typechildta["news"] = this.templist.join(",");

          this.getnewsList(1, this.templist.join(","));
        }
      }

      //this.getallchilddocid([this.alldoctype[1]], this.templist);
      //console.log("templist", this.templist);
      // this.getnoticeList(1);

      // this.getnewsList(1);
    });*/
      listCmsBlock({
          pageSize: 999,
          pageNum: 1,
          name: "home",
      }).then((res) => {
          this.swiper = res.data.list;
      });
      this.getNum();
      this.getuserList(279);
      this.getnoticeList(1);
      this.getfileList(1);
      this.getnewsList(1);

      this.bread.push({
          name: "广西来宾广投银海铝业有限公司",
          id: 279,
      });


     
      
   
  },
  methods: {
      
      userChange(e) {
          console.log(e);
          let routeUrl = this.$router.resolve({
              path: "/core/system/user",
              query: {
                  keyword: e.name, //要传的参数
              },
          });
          this.$router.push(routeUrl.href.substr(1));
      },
      domore(ty) {
          let routeUrl = "";
          if (ty == "tzgg") {
              routeUrl = this.$router.resolve({
                  path: "/cms/archives",
                  // query: {
                  //   cid: 120, //要传的参数
                  // },
              });
          } else if (ty == "xxyd") {
              routeUrl = this.$router.resolve({
                  path: "/form/data/index/26500254121989",
                  // query: {
                  //   cid: 19, //要传的参数
                  // },
              });
          } else if (ty == "zdgl") {
              routeUrl = this.$router.resolve({
                  path: "/cms/archives",
                  // query: {
                  //   cid: 14, //要传的参数
                  // },
              });
          }

          if (routeUrl == "") {
              return false;
          }

          //window.open(routeUrl.href, "_blank");
          this.$router.push(routeUrl.href.substr(1));
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
          // 状态列字体颜色
          if (column.property == "update_time") {
              return "color: #00557f;";
          }
      },
      rowStyle({ row }) {
          return {
              cursor: "pointer",
          };
      },
      search() {
          this.pageNum = 1;
          this.value = this.show;
          if (this.show == "") {
              this.getuserList(279);
          } else {
              listUser({
                  pageNum: 1,
                  pageSize: 9999,
                  keyword: this.value,
                  ignore_datascope: "0",
                  status: "1",
                  order_by: "gbk",
              }).then((res) => {
                  this.tableData = [];
                  this.pageNum = 1;
                  for (let item of res.data.list) {
                      this.tableData.push({
                          id: item.id,
                          name: item.nickname,
                          deptname: item.dept.name,
                          phone: item.mobile,
                      });
                  }
                  let a = [];
                  let arr = []; //定义外面的数组
                  this.total = 0;
                  for (let i = 1; i <= this.tableData.length; i++) {
                      //循环遍历
                      if (i % 5 == 1) {
                          //每当余数为1时，就重新建立数组，
                          a = [];
                          arr.push(a); //将数组存到外面的数组中
                      }
                      if (this.tableData[i - 1]) {
                          this.total++;
                          a.push(this.tableData[i - 1]); //将元素存到里面的数组中
                      }
                  }
                  this.tableData = arr;
                  this.showList = this.tableData[this.pageNum - 1];
              });
          }
      },
      getNum() {
          StatProcess().then((res) => {
              this.buttonList1[0].num = res.data.todo;
              this.buttonList1[1].num = res.data.done;
              this.buttonList2[0].num = res.data.apply;
              this.buttonList2[1].num = res.data.copy;
          });
      },
      changeDept(item) {
          if (!item.phone) {
              this.getuserList(item.id);
              this.bread.push({
                  name: item.name,

                  id: item.id,
              });
          }
      },
      backDeptList() {
          if (this.bread.length > 1) {
              this.bread.pop();
              this.getuserList(this.bread[this.bread.length - 1].id);
          }
      },
      handleSetLineChartData(type) {
          this.lineChartData = lineChartData[type];
      },
      getFlow(e) {
          if (e == "more") {
              let routeUrl = this.$router.resolve({
                  path: "/bpm/task/flowList",
              });
              window.open(routeUrl.href, "_blank");
          } else if (e == "作业票") {
              let routeUrl = this.$router.resolve({
                  path: "/bpm/tabledata/list/106",
                  query: {},
              });
              //window.open(routeUrl.href, "_blank");
              this.$router.push(routeUrl.href.substr(1));
          } else {
              this.$message("功能暂未开放");
              /*getBpmFlow(e).then((res) => {
          let routeUrl = this.$router.resolve({
            path:
              "/bpm/task/task?" +
              "?resourceId=" +
              res.data.resource_id +
              "&title=" +
              res.data.name,
          });
          window.open(routeUrl.href, "_blank");
        });*/
          }
      },
      getuserList(e) {
          listUser({
              pageNum: 1,
              pageSize: 5,
              keyword: this.value,
              ignore_datascope: "0",
              status: "1",
              order_by: "gbk",
          }).then((res) => {
              if (this.alltotal == 1) {
                  this.alltotal = res.data.total;
              }
          });
          let qeury = {
              pageNum: 1,
              pageSize: 999,
              dept_id: e,
              ignore_datascope: "0",
              status: "1",
              order_by: "gbk",
          };
          this.tableData = [];
          this.total = 0;
          listDept({
              ignore_datascope: this.ignoreDatascope,
              order_by: "gbk",
          }).then((res) => {
              this.showList = [];
              for (let item of res.data.list) {
                  if (item.parent_id == e) {
                      this.tableData.push({
                          name: item.name,
                          id: item.id,
                      });
                  }
              }
              listUser(qeury).then((res) => {
                  for (let item of res.data.list) {
                      this.tableData.push({
                          id: item.id,
                          name: item.nickname,
                          deptname: item.dept.name,
                          phone: item.mobile,
                      });
                  }
                  let a = [];
                  let arr = []; //定义外面的数组
                  for (let i = 1; i <= this.tableData.length; i++) {
                      //循环遍历
                      if (i % 5 == 1) {
                          //每当余数为1时，就重新建立数组，
                          a = [];
                          arr.push(a); //将数组存到外面的数组中
                      }
                      if (this.tableData[i - 1]) {
                          this.total++;
                          a.push(this.tableData[i - 1]); //将元素存到里面的数组中
                      }
                  }
                  this.tableData = arr;
                  this.showList = this.tableData[this.pageNum - 1];
              });
          });
      },
      getallchilddocid(list, templist) {
          for (let i in list) {
              if (list[i].children != null) {
                  templist.push(list[i].id);
                  this.getallchilddocid(list[i].children, templist);
              } else {
                  templist.push(list[i].id);
              }
          }
      },
      getnoticeList(e) {
          listCmsArchives({
              pageNum: e,
              pageSize: 5,
              channel_id: 120,
          }).then((res) => {
              this.noticetotal = res.data.total;
              for (let item of res.data.list) {
                  item.update_time = this.getYMD(item.update_time * 1000);
              }
              this.noticeList = res.data.list;
          });
      },
      getfileList(e) {
          listCmsArchives({
              pageNum: e,
              pageSize: 5,
          }).then((res) => {
              this.filetotal = res.data.total;
              for (let item of res.data.list) {
                  item.update_time = this.getYMD(item.update_time * 1000);
              }
              this.fileList = res.data.list;
          });
      },
      getnewsList(e) {
          FormxShowList("26500254121989", {
              pageNum: e,
              pageSize: 5,
              fieldval: {},
              querytype: {},
              sortinfo: {
                  id: "desc",
              },
          }).then((res) => {
              this.newstotal = res.data.total;
              for (let item of res.data.list) {
                  if (item.input77680) {
                      item.title = item.input77680;
                  }
                  item.update_time = this.getYMD(item.update_time * 1000);
              }
              this.newsList = res.data.list;
          });

          // listCmsArchives({
          //   pageNum: e,
          //   pageSize: 5,
          //   channel_id: "94",
          // }).then((res) => {
          //   this.newstotal = res.data.total;
          //   for (let item of res.data.list) {
          //     item.update_time = this.getYMD(item.update_time * 1000);
          //   }
          //   this.newsList = res.data.list;
          // });
      },
      add(val) {
          switch (val) {
              case "user": {
                  this.pageNum++;
                  this.showList = this.tableData[this.pageNum - 1];
                  break;
              }
              case "notice": {
                  this.noticepageNum++;
                  this.getnoticeList(this.noticepageNum);
                  break;
              }
              case "file": {
                  this.filepageNum++;
                  this.getfileList(this.filepageNum);
                  break;
              }
              case "news": {
                  this.newspageNum++;
                  this.getnewsList(this.newspageNum);
                  break;
              }
          }
      },
      last(val) {
          switch (val) {
              case "user": {
                  this.pageNum--;
                  this.showList = this.tableData[this.pageNum - 1];
                  break;
              }
              case "notice": {
                  this.noticepageNum--;
                  this.getnoticeList(this.noticepageNum);
                  break;
              }
              case "file": {
                  this.filepageNum--;
                  this.getfileList(this.filepageNum);
                  break;
              }
              case "news": {
                  this.newspageNum--;
                  this.getnewsList(this.newspageNum);
                  break;
              }
          }
      },
      changePage(e) {
          this.pageNum = e;
          this.showList = this.tableData[this.pageNum - 1];
      },
      changenoticePage(e) {
          this.noticepageNum = e;
          this.getnoticeList(this.noticepageNum);
      },
      changefilePage(e) {
          this.filepageNum = e;
          this.getfileList(this.filepageNum);
      },
      changenewsPage(e) {
          this.newspageNum = e;
          this.getnewsList(this.newspageNum);
      },
      push(url) {
          let routeUrl = this.$router.resolve({
              path: "/" + url,
          });
          window.open(routeUrl.href, "_blank");
      },
      goDetail(item) {
          console.log(item);
          if (item.fmodel_id) {
              let routeUrl = this.$router.resolve({
                  path: "/form/data/index/26500254121989",
                  query: {
                      id: item.id,
                  },
              });
              //window.open(routeUrl.href, "_blank");
              this.$router.push(routeUrl.href.substr(1));
          } else {
              let routeUrl = this.$router.resolve({
                  path: "/home/detail",
                  query: {
                      obj: JSON.stringify(item),
                  },
              });
              //window.open(routeUrl.href, "_blank");
              this.$router.push(routeUrl.href.substr(1));
          }
      },
      getYMD(val) {
          var date = new Date(val);
          var years = date.getFullYear();
          var months = date.getMonth();
          var days = date.getDate();
          var weeks = date.getDay();
          var date1 = new Date(`${years}-${months + 1}-${days}`);
          var times = date - date1;
          var hours = parseInt(times / 1000 / 60 / 60);
          var minutes = parseInt((times / 1000 / 60) % 60);
          var seconds = parseInt((times / 1000) % 60);
          var zhou;
          if (seconds <= 9) {
              seconds = "0" + seconds;
          }
          if (minutes <= 9) {
              minutes = "0" + minutes;
          }
          if (hours <= 9) {
              hours = "0" + hours;
          }
          months = months + 1;
          if (months <= 9) {
              months = "0" + months;
          }

          if (days <= 9) {
              days = "0" + days;
          }

          return years + "年" + months + "月" + days + "日";
      },
  },
};
</script>

<style lang="scss">
.welcom {
  font-size: 28px;
  text-align: center;
  line-height: 100px;
}

.dashboard-promote .el-row {
  margin-bottom: 20px;
  font-size: 14px;
}

.dashboard-promote .el-row .jz {
  height: 500px;
}

.dashboard-promote .el-row .kj {
  height: 300px;
}

.dashboard-promote .el-row .xx {
  height: 200px;
}

.git-res {
  margin-top: 20px;
}

.git-res .el-link {
  margin-right: 30px;
}

ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}

.product li {
  margin-bottom: 20px;
  float: left;
  width: 210px;
}
.el-card__header {
  div {
      h4 {
          margin-top: 0;
          color: #fff;
          // border-left: 5px solid #bbb;
          padding: 5px 0;
          padding-left: 10px;
          background-color: #1890ff;
          font-family: SourceHanSansSC-regular;
      }
  }
}

.dashboard-editor-container {
  padding: 10px 0;
  /*background-color: rgb(240, 242, 245);*/
  position: relative;

  .chart-wrapper {
      background: #fff;
      padding: 16px 16px 0;
      margin-bottom: 32px;
  }

  .cardBox {
      padding: 10px;
  }

  .circle {
      background-color: #1890ff;
      width: 10px;
      height: 10px;
      border-radius: 50%;
  }

  .el-card {
      .el-card__body {
          min-height: 300px;
      }

      .el-card__header {
          padding: 1px 0px;
          border: 0px solid;
          height: 40px;
      }
  }

  .bodyer {
      margin-left: -7px;
  }

  .bottom {
      position: absolute;
      bottom: 15px;
  }

  .carousel-item {
      text-align: center;
      position: absolute;
      left: 1rem;
      bottom: 1rem;
      color: white;
      width: 880px;
      /* text-decoration-line: underline; */
      font-weight: 700;
      font-family: Georgia, "Times New Roman", Times, serif;
      font-size: 24px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }

  .buttonGround {
      display: flex;
      justify-content: space-between;
      align-self: center;
  }

  .item {
      margin: 10px 20px;
  }

  .button {
      .icon {
          width: 65px;
          height: 65px;
      }

      .buttonTitle {
          white-space: normal;
          margin-top: 5px;
          //  overflow: hidden;
          // text-overflow: ellipsis;
      }
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
      padding: 8px;
  }
}

.visualization {
  margin: 10px 0;
  padding: 10px;
  background-color: #1890ff;
  color: #fff;
}
.bgindex-more {
  float: right;
  margin-right: 5px;
  cursor: pointer;
}
</style>
